import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export interface NadaValuationRequest {
    automobile_id?: number
    vin?: string
    condition?: 'N' | 'U'
    trim?: string
    dealer_state?: string
    option_codes?: string[]
    mileage?: number
    parent_application_id?: number
}

export interface NadaValuationResolvedResponse {
    resolved: true
    nada_id: string
    automobile_id: number
    year: number
    make: string
    make_id: number
    model: string
    model_id: number
    trim: string
    value: string
}

export interface NadaValuationTrimPickerResponse {
    resolved: false
    year: number
    make: string
    make_id: number
    model: string
    model_id: number
    available_automobile_ids: [number, ...number[]]
}

export interface NadaValuationNoValuationResponse {
    resolved: true
    automobile_id: number
    year: number
    make: string
    make_id: number
    model: string
    model_id: number
    trim: string
}

export interface NadaValuationNotFoundResponse {
    resolved: false
    available_automobile_ids: []
}

export type NadaValuationResponse =
    | NadaValuationResolvedResponse
    | NadaValuationTrimPickerResponse
    | NadaValuationNoValuationResponse
    | NadaValuationNotFoundResponse

export default async function postNadaValuation(
    request: NadaValuationRequest,
): Promise<NadaValuationResponse> {
    const url = `${config.API_BASE_URL}/api/v3/automobile/nada-valuation/`

    try {
        const { data } = await axios.post(url, request, {
            withCredentials: true,
        })

        return data as NadaValuationResponse
    } catch (error) {
        const axiosError = error as AxiosError<{ error: string }>

        if (!axiosError.response?.data?.error) {
            OctaneLogger.error('Failed NADA valuation request', {
                status: axiosError.response?.status,
            })
        }

        throw error
    }
}
